export const domain = process.env.VUE_APP_DOMAIN
export const apiDomain = domain + 'api/'
export const domain2 = process.env.VUE_APP_DOMAIN2
export const apiDomain2 = domain2 + 'api/'

export const logUrl = apiDomain + 'log'
export const lockUrl = apiDomain + 'lock'
export const loginUrl = domain + 'auth/login'
export const userUrl = apiDomain + 'user'
export const roleUrl = apiDomain + 'role'
export const userTokenUrl = apiDomain + 'user/token'
export const productUrl = apiDomain + 'product'
export const productCategoryUrl = productUrl + '/category'
export const productTypeUrl = productUrl + '/type'
export const productPurchasingUrl = productUrl + '/purchasing'
export const productVariantUrl = productUrl + '/variant'
export const vendorUrl = apiDomain + 'vendor'
export const vendorTypeUrl = apiDomain + 'vendor-type'
export const uomUrl = apiDomain + 'uom'
export const uomTypeUrl = apiDomain + 'uom-type'
export const uomCategoryUrl = apiDomain + 'uom-category'
export const priceListUrl = apiDomain + 'price-list'
export const priceListGroupUrl = apiDomain + 'price-list/group'
export const purchasingUrl = apiDomain + 'purchasing'
export const purchasingOrderUrl = purchasingUrl + '/order'
export const purchasingDetailUrl = purchasingUrl + '/detail'
export const purchasingTypeUrl = purchasingUrl + '/type'
export const branchUrl = apiDomain + 'branch'
export const taxUrl = apiDomain + 'tax'
export const warehouseUrl = apiDomain + 'warehouse'
export const stockAdjustmentUrl = apiDomain + 'stock/adjustment'
export const setQtyTotalUrl = apiDomain + 'stock/set-total'
export const setRowUrl = apiDomain + 'stock/set-row'
export const setMultiRowUrl = apiDomain + 'stock/set-multi-row'
export const inventoryUrl = apiDomain + 'inventory'
export const paymentTypeUrl = apiDomain + 'payment/type'
export const paymentMethodUrl = apiDomain + 'payment/method'
export const bankUrl = apiDomain + 'bank'
export const bankGroupUrl = apiDomain + 'bank-group'
export const salesUrl = apiDomain + 'sale'
export const salesDetailUrl = salesUrl + '/detail'
export const salesPaymentUrl = salesUrl + '/payment'
export const salesReturUrl = salesUrl + '/retur'
export const cityUrl = apiDomain + 'city'
export const stateUrl = apiDomain + 'state'
export const areaUrl = apiDomain + 'area'
export const customerUrl = apiDomain + 'customer'
export const organizationUrl = apiDomain + 'organization'
export const jobPositionUrl = apiDomain + 'job-position'
export const deliveryUrl = apiDomain + 'sale/delivery'
export const workOrderTermUrl = apiDomain + 'work/order/term'
export const costUrl = apiDomain + 'cost'
export const reportUrl = apiDomain + 'report'
export const messageUrl = apiDomain + 'message'
export const testMsgUrl = apiDomain + 'test-msg'
export const messageTemplateUrl = apiDomain + 'message-template'
export const saleOrderUrl = apiDomain + 'sale-order'
export const projectUrl = apiDomain + 'project-manage'
export const chartOfAccountUrl = apiDomain + 'account/chart-of-account'
export const accountUrl = apiDomain + 'account'
export const chartAccountTypeUrl = apiDomain + 'account/type'
export const journalUrl = apiDomain + 'journal'
export const financeUrl = apiDomain + 'finance'
export const promoUrl = salesUrl + '/promo'
export const packageUrl = productUrl + '/package'
export const cardUrl = customerUrl + '/customer'
export const levelUrl = customerUrl + '/level'
export const variantUrl = apiDomain + 'variant'
export const assetUrl = apiDomain + 'asset'
export const pointOfSaleUrl = apiDomain + 'sale/point-of-sales'
export const manufactureUrl = apiDomain + 'manufacture'
export const companyUrl = apiDomain + 'company'
export const termDueDateUrl = apiDomain + 'term-due-date'
export const employeeUrl = apiDomain + 'employee'
export const cohUrl = apiDomain + 'cash-on-hand'
export const returnUrl = apiDomain + 'return'
export const paymentUrl = apiDomain + 'payment'
export const convertUrl = apiDomain + 'convert'
export const returUrl = apiDomain + 'return'
export const saleCommissionUrl = apiDomain + 'sale-commission'
export const reportTransactionUrl = apiDomain + 'report-transaction'
export const settingUrl = apiDomain + 'setting'
export const tableUrl = apiDomain + 'table'
export const ledgerUrl = apiDomain + 'ledger-bank'
export const unitUrl = apiDomain + 'unit'

// domain 2
export const printInventoryUrl = domain2 + 'inventory'
export const printInvoiceUrl = domain2 + 'sale/print'
export const woTermUrl = apiDomain + 'wo/term'
export const woTermCategoryUrl = apiDomain + 'wo/term/category'
export const workshopUrl = apiDomain + 'workshop'
export const workshopPaymentUrl = apiDomain + 'workshop/payment'
export const workshopTypeUrl = apiDomain + 'workshop/type'
export const workshopDetailUrl = apiDomain + 'workshop/detail'
export const workshopPrintUrl = domain2 + 'workshop/print'
export const workshopPrintInvoiceUrl = domain2 + 'workshop/print/invoice'
export const costPrintReportUrl = domain2 + 'cost/print'
export const callPrintSoUrl = domain2 + 'call/print/so'
export const callPrintPoUrl = domain2 + 'call/print/po'
export const callPrintBstkUrl = domain2 + 'call/print/bstk'
export const callPrintBstpUrl = domain2 + 'call/print/bstp'
export const callPrintInvoiceUrl = domain2 + 'call/print/invoice'
export const callPrintKwitansiUrl = domain2 + 'call/print/kwitansi'
export const product2Url = apiDomain2 + 'product'
export const sale2Url = apiDomain2 + 'sale'
export const purchasing2Url = apiDomain2 + 'purchasing'
export const inventory2Url = apiDomain2 + 'inventory'
export const manufacture2Url = apiDomain2 + 'manufacture'
export const customer2Url = apiDomain2 + 'customer'
export const report2Url = apiDomain2 + 'report'
export const import2Url = apiDomain2 + 'import'

// startup
export const companyStartUrl = domain + 'company'
export const companyNo = 'C0002'

export const getHeader = function () {
  try {
    const authUser = window.localStorage.getItem('authUser')
    if (!authUser) {
      return null
    }

    const tokenData = JSON.parse(authUser)
    if (!tokenData || !tokenData.token) {
      return null
    }

    const headers = {
      Accept: 'application/json',
      Authorization: 'Bearer ' + tokenData.token
    }

    return headers
  } catch (e) {
    window.localStorage.removeItem('authUser')
    return null
  }
}
